import CantileverTheme from 'styles/cantileverTheme'

import { AsPipelineStatus, AsScanStatusType } from './rolodexEntryTypes'

export const getStatusColor = (status: AsScanStatusType) => {
  switch (status) {
    case 'process':
      return CantileverTheme.colors.grayscale[600]
    case 'error':
      return 'red'
    case 'finish':
      return 'green'
    default:
      return 'grey'
  }
}

export const buildStatusMap = (status: AsPipelineStatus | undefined) =>
  Object.entries(status?.scan_level || {}).reduce<
    Record<string, AsScanStatusType>
  >((acc, [scanId, scanStatus]) => {
    const accCopy = { ...acc }
    if (
      scanStatus.sync.status === 'process' ||
      scanStatus.upload.status === 'process' ||
      scanStatus.auto_measure.status === 'process' ||
      scanStatus.sync.status === 'wait' ||
      scanStatus.upload.status === 'wait' ||
      scanStatus.auto_measure.status === 'wait'
    ) {
      accCopy[scanId] = 'process'
    } else if (
      scanStatus.sync.status === 'error' ||
      scanStatus.upload.status === 'error' ||
      scanStatus.auto_measure.status === 'error'
    ) {
      accCopy[scanId] = 'error'
    } else {
      accCopy[scanId] = 'finish'
    }
    return accCopy
  }, {})
